import React from "react";
import { EmployeeManagePlansModulesContainer } from "../../../containers";

const EmployeeManagePlansModules = (props) => {
  return <EmployeeManagePlansModulesContainer {...props} />;
};

export default EmployeeManagePlansModules;
